import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './redux/store'

const rootElement = document.getElementById('root')

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as HTMLElement)
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  )
}

// PWA: Register service worker with update detection
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { updateViaCache: 'none' })
      .then(registration => {
        console.log('✅ ServiceWorker registered:', registration)
        
        // Check for updates every 30 seconds
        setInterval(() => {
          registration.update()
        }, 30000)
        
        // Handle updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing
          
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker available, prompt user to refresh
                console.log('🔄 New version available! Reloading...')
                
                // Auto-reload after a short delay
                setTimeout(() => {
                  window.location.reload()
                }, 1000)
              }
            })
          }
        })
      })
      .catch(error => {
        console.log('❌ ServiceWorker registration failed:', error)
      })
    
    // Listen for controller change and reload
    let refreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true
        console.log('🔄 Controller changed, reloading page...')
        window.location.reload()
      }
    })
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
